import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from '../../../_services';
import { Config } from '../../../_models';

declare let mLayout: any;
@Component({
    selector: "app-header-nav",
    templateUrl: "./header-nav.component.html"
})
export class HeaderNavComponent implements OnInit, AfterViewInit {
    currentUser = JSON.parse(localStorage.getItem('currentUser'));
    userName: string;
    userEmail: string;
    data: Config = new Config(null, null, null, null, null, null, null);
    constructor(
        private _userService: AuthService
    ) { }
    ngOnInit() {
    }
    ngAfterViewInit() {
        setTimeout(() => {
            if (this.currentUser) {
                this.userName = (this.currentUser) ? this.currentUser.user.name : "";
                if (!this.userName) {
                    let email = this.currentUser.user.email;
                    this.userName = email.substring(0, email.indexOf('@'));
                }
            }
            this.userEmail = (this.currentUser) ? this.currentUser.user.email : "";
        }, 200);

        mLayout.initHeader();

    }

}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/layouts/header-nav/header-nav.component.ts